import { Effect, Reducer, Subscription } from 'umi';
import menusSource from '../../config/menu.config';

const GlobalModel = {
  namespace: 'global',
  state: {
    name: '',
    menusData: menusSource,
    userInfo: {
      id: '',
      name: '',
    },
  },
  effects: {
    *queryUserInfo({ payload }, { call, put }) {
      const userInfo = localStorage.getItem('userInfo');
      yield put({
        type: 'save',
        payload: {
          userInfo: JSON.parse(userInfo),
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    // 启用 immer 之后
    // save(state, action) {
    //   state.name = action.payload;
    // },
  },
  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        const reg = /^\/login/g;
        if (!reg.test(pathname)) {
          dispatch({
            type: 'queryUserInfo',
            payload: {},
          });
        }
      });
    },
  },
};

export default GlobalModel;
